import React from 'react'
import {
    // BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom'
import Home from '../Home'
import Login from '../Login'
import Page from '../Page'

const RouterApp = () => (
    <Switch>
        <Route exact path="/" component={Home} />
        <Route exact name="Login" path="/:slug" component={Login} />
        <Route exact name="Page" path="/:slug/page" component={Page} />
    </Switch>
)

export default RouterApp


// WEBPACK FOOTER //
// ./src/Router/index.js